'use client';

import { LoginForm } from '@/modules/authentication/presentation/forms';
import type { LoginFormModel } from '@/modules/authentication/view-model';
import {  LoginFormSchema, useLoginForm } from '@/modules/authentication/view-model';

import { Form } from '@packages/hook-form-wrapper';

export const LoginFormContainer = () => {
	const { execute } = useLoginForm();

	return (
		<Form.Provider<LoginFormModel> onSubmit={execute} schema={LoginFormSchema}>
			<LoginForm />
		</Form.Provider>
	);
};
